import router from '@/routes/index';
import routerNames from '@/const/routerConstants';
import store from '@/store/index';

import { callApp } from '@/utils/app/callApp.js';

export function errorLogout() {
  // 쿠키제거
  store.commit('cleanToken');

  // 앱 로그아웃 호출
  if (store.getters.IS_ANDROID || store.getters.IS_IOS) {
    callApp.logout();
  }
  // 로그인페이지로 이동
  router.push({
    name: routerNames.Login,
    params: { type: 'authExpired' },
  });
}
